import axios from 'axios';

import type {
  PersistPayload,
  ProductUnitOfMeasureResponse,
  UomTypeResponse,
} from '../../products/product-details/components/tabs/uom/uom-types';

const baseForProduct = (productId: number): string => `/products/${productId}/unitsOfMeasure`;

export const getProductUnitsOfMeasure = (productId: number): Promise<ProductUnitOfMeasureResponse[]> =>
  axios.get(baseForProduct(productId)).then((response) => response.data ?? []);

export const createProductUnitOfMeasure = (productId: number, payload: PersistPayload): Promise<ProductUnitOfMeasureResponse> =>
  axios.post(baseForProduct(productId), payload).then((response) => response.data);

export const updateProductUnitOfMeasure = (
  productId: number,
  productUnitOfMeasureId: number,
  payload: PersistPayload,
): Promise<ProductUnitOfMeasureResponse> =>
  axios.put(`${baseForProduct(productId)}/${productUnitOfMeasureId}`, payload).then((response) => response.data);

export const deleteProductUnitOfMeasure = (productId: number, productUnitOfMeasureId: number): Promise<void> =>
  axios.delete(`${baseForProduct(productId)}/${productUnitOfMeasureId}`);

export const getUomTypes = (): Promise<UomTypeResponse[]> => axios.get('/unitsOfMeasure/types').then((response) => response.data ?? []);
